import { render, staticRenderFns } from "./FormOptionCategoriesPage.vue?vue&type=template&id=9adfa2a6&"
import script from "./FormOptionCategoriesPage.vue?vue&type=script&lang=js&"
export * from "./FormOptionCategoriesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports